namespace GeniuzPOS.SalePromoCamp {
    export class PsPromoDtColumns {
        static columnsKey = 'SalePromoCamp.PsPromoDt';
    }
}
